import { generatePath } from 'react-router'

export const endpoints = {
    goalsOptions: (uuid: string): string => generatePath('goals/company/:uuid/solution-goal-card-options/', { uuid }),
    myGoal: (uuid: string): string => generatePath('/goals/company/:uuid/my-goals/', { uuid }),
    insightData: (uuid: string): string => generatePath('/goals/company/:uuid/insight-data/', { uuid }),
}
